<template>
    <b-modal
        id="add-sub-group-modal"
        v-model="modal"
        modal-class="apprentice-default-modal add-sub-group-modal"
        :title="$t('group.add_subproject')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="storeSubGroup">
        <div class="sub-project-name">
            <b-form-group
                :label="$t('common.name') + ':'"
                label-for="sub-group-name-input">
                <b-form-input
                    id="sub-group-name-input"
                    v-model="name"
                    autofocus
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-add-sub-group-modal-component',
    emits: ['sub-group-added'],
    data() {
        return {
            name: '',
            group: {},
            hasError: false,
            modal: false,
        };
    },

    methods: {
        show(group) {
            this.name = '';
            this.group = group;
            this.modal = true;
        },

        storeSubGroup(bvModalEvent) {
            this.hasError = false;

            if (this.name === '') {
                this.hasError = true;
                bvModalEvent.preventDefault();
            }

            const data = {
                name: this.name,
            };

            this.alert.saving();
            this.axios.post(this.routes.createSubGroup(this.group.group_id), data).then(
                (response) => {
                    this.alert.success();
                    this.$emit('sub-group-added', this.group.group_id, response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
